/* eslint-disable @typescript-eslint/no-unsafe-assignment -- WIP */
/* eslint-disable @typescript-eslint/no-unsafe-argument -- WIP */
import { dequal } from 'dequal';
export class GlobalModel {
    static clearRAFTimeout = (rafIdInfo) => {
        if (rafIdInfo && rafIdInfo.id) {
            cancelAnimationFrame(rafIdInfo.id);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- WIP
    static debounceRAF = (fn, time) => {
        const rafIdInfo = {
            id: null,
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- WIP
        return (...params) => {
            if (typeof fn !== 'function' || typeof time !== 'number') {
                return;
            }
            const startTime = performance.now();
            const wait = (timestamp) => {
                const elapsedTime = timestamp - startTime;
                if (elapsedTime < time) {
                    GlobalModel.clearRAFTimeout(rafIdInfo);
                    rafIdInfo.id = requestAnimationFrame(wait);
                }
                else {
                    GlobalModel.clearRAFTimeout(rafIdInfo);
                    fn(...params);
                }
            };
            GlobalModel.clearRAFTimeout(rafIdInfo);
            rafIdInfo.id = requestAnimationFrame(wait);
        };
    };
    static performanceNow() {
        return window.performance.now();
    }
    static setRAFTimeout = (callback, timeout) => {
        const rafIdInfo = {
            id: null,
        };
        if (typeof callback !== 'function' || typeof timeout !== 'number') {
            return rafIdInfo;
        }
        const startTime = window.performance.now();
        const wait = (timestamp) => {
            const elapsedTime = timestamp - startTime;
            if (elapsedTime < timeout) {
                GlobalModel.clearRAFTimeout(rafIdInfo);
                rafIdInfo.id = requestAnimationFrame(wait);
            }
            else {
                GlobalModel.clearRAFTimeout(rafIdInfo);
                callback();
            }
        };
        rafIdInfo.id = requestAnimationFrame(wait);
        return rafIdInfo;
    };
    static hasDependencyListDiff = ({ comparator, newValue, prevValue, }) => {
        if (newValue.length !== prevValue.length) {
            throw new Error('Inconsistent length of dependency list array');
        }
        let hasChange;
        if (typeof comparator === 'function') {
            hasChange = comparator({
                newValue,
                prevValue,
            });
        }
        else if (comparator) {
            hasChange = !dequal(newValue, prevValue);
        }
        else {
            hasChange = newValue.some((dep, depIndex) => dep !== prevValue[depIndex]);
        }
        return hasChange;
    };
    static hasValueDiff = ({ comparator, newValue, prevValue, }) => {
        let hasDiff;
        if (typeof comparator === 'function') {
            hasDiff = comparator({ newValue, prevValue });
        }
        else if (comparator) {
            hasDiff = !dequal(newValue, prevValue);
        }
        else {
            hasDiff = newValue !== prevValue;
        }
        return hasDiff;
    };
}
/* eslint-enable @typescript-eslint/no-unsafe-assignment */
/* eslint-enable @typescript-eslint/no-unsafe-argument */
